import { styled } from '@mui/material';
import { TableHead } from '@mui/material';

export const TableHeadMUI = styled(
  (props: any) => (
    <TableHead className={props?.className} {...props}>
      {props?.children}
    </TableHead>
  ),
  {}
)(({ theme, className, children, ...props }) => {
  return {};
});
